<p-dialog
  [modal]="true"
  [header]="header"
  [(visible)]="display"
  appendTo="body"
  [breakpoints]="{ '640px': '100vw' }"
  [style]="{ width: '25vw', backgroundColor: '#fff' }"
  (onHide)="closeModal()"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [closable]="false"
>
  <div class="p-d-flex">
    <form class="relogin p-fluid p-grid p-as-center" [formGroup]="form" (document:keydown.control.shift.z)="automaticLogin()">
      <div class="p-field p-col-12 p-mb-4">
        <div class="login-title">Login</div>
        <div class="login-message">Your session has timed out.<br />Please log in again to continue.</div>
      </div>

      <div class="p-field p-col-12 p-mb-4">
        <span class="p-float-label">
          <input pInputText id="userName" type="text" formControlName="username" (keydown.enter)="login()" />
          <label for="userName">User Name</label>
        </span>
      </div>

      <div class="p-field p-col-12 p-mb-6">
        <span class="p-float-label">
          <input
            pPassword
            id="userPassword"
            type="password"
            formControlName="password"
            [feedback]="false"
            (keydown.enter)="login()"
          />
          <label for="userPassword">Password</label>
        </span>
      </div>

      <div class="p-field p-col">
        <p-button label="Login" (click)="login()"></p-button>
      </div>
    </form>
  </div>
</p-dialog>

<p-confirmDialog
  #messageDialog
  key="reauth-message"
  [breakpoints]="{ '960px': '75vw', '640px': '100vw' }"
  [style]="{ width: '50vw', backgroundColor: '#fff' }"
  appendTo="body"
  [baseZIndex]="1000"
>
  <ng-template pTemplate="footer">
    <p-button label="Ok" (click)="messageDialog.accept()" styleClass="p-button-outlined p-button-secondary"></p-button>
  </ng-template>
</p-confirmDialog>
